/**
 * Power BI dashboard URL map and helper functions.
 */

export const POWER_BI_DASHBOARDS = {
  "ALS DNK PWD":
    "https://app.powerbi.com/reportEmbed?reportId=be2fefb1-a5a9-4e7c-93ad-e139d4ddb8d7&autoAuth=true&ctid=e8479183-da5c-4666-910d-38afe2ff031b",
  "ALS Bahria Enclave":
    "https://app.powerbi.com/reportEmbed?reportId=30e01029-3451-45ce-861b-1f5468b1d60e&autoAuth=true&ctid=e8479183-da5c-4666-910d-38afe2ff031b",
  "ALS Top City":
    "https://app.powerbi.com/reportEmbed?reportId=c64d339f-a0c8-4156-b55f-b70fb6a01eee&autoAuth=true&ctid=e8479183-da5c-4666-910d-38afe2ff031b",
  "ALS DNK Swabi":
    "https://app.powerbi.com/reportEmbed?reportId=9ea5bef6-3db7-4553-ab52-eeaaf88954ef&autoAuth=true&ctid=e8479183-da5c-4666-910d-38afe2ff031b",
  "ALS Bahria Town":'https://app.powerbi.com/reportEmbed?reportId=d1a77446-1e25-4a5d-aa16-d19937fde0b4&autoAuth=true&ctid=e8479183-da5c-4666-910d-38afe2ff031b',
  "ALS Metro City":'https://app.powerbi.com/reportEmbed?reportId=c9a7a4af-d696-47e6-b726-b8fb8ed3bc37&autoAuth=true&ctid=e8479183-da5c-4666-910d-38afe2ff031b'
};

/** Normalize a campus name for case-insensitive comparison. */
export const normalizeCampusName = (name = "") =>
  name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

/** Return the configured raw Power BI URL for a campus name, if present. */
export const getPowerBiDashboardForCampus = (campusName = "") => {
  const normalizedCampusName = normalizeCampusName(campusName);
  const dashboardEntry = Object.entries(POWER_BI_DASHBOARDS).find(
    ([configuredCampusName, dashboardUrl]) =>
      dashboardUrl &&
      normalizeCampusName(configuredCampusName) === normalizedCampusName,
  );

  return dashboardEntry?.[1] || null;
};

/** Append standard Power BI query params to a report URL. */
export const buildPowerBiDashboardUrl = (url) => {
  const dashboardUrl = new URL(url);
  dashboardUrl.searchParams.set("filterPaneEnabled", "false");
  dashboardUrl.searchParams.set("navContentPaneEnabled", "true");
  dashboardUrl.searchParams.set("pageView", "actualSize");
  return dashboardUrl.toString();
};
